"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("@tippyjs/react");
var react_2 = require("react");
var reactstrap_1 = require("reactstrap");
require("../../styles/ticket.css");
require("tippy.js/dist/tippy.css");
var ticket_1 = require("../../api/ticket");
var react_moment_1 = require("react-moment");
var msal_react_1 = require("@azure/msal-react");
var authConfig_1 = require("../../authConfig");
var graph_1 = require("../../graph");
var msal_react_2 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
function Document(props) {
    var downloadAll = function (e, files) {
        e.preventDefault();
        files.map(function (item) {
            window.open(item.path);
        });
    };
    return (React.createElement(reactstrap_1.Row, { className: "row-component" },
        React.createElement(reactstrap_1.Col, { lg: "1" }),
        React.createElement(reactstrap_1.Col, { lg: "11", id: "file-upload-col" },
            React.createElement("div", { className: "file-upload" },
                React.createElement("div", { id: "upload-content" }, props && props.attachments ? props.attachments.map(function (item) { return (React.createElement("div", { className: "content" },
                    React.createElement("a", { href: item.path },
                        React.createElement("h6", null,
                            React.createElement("img", { src: "./insertphoto.svg" }),
                            " ",
                            item.name)))); }) : null),
                React.createElement("div", { id: "uploadDocument" }, props.attachments.length > 0 ? React.createElement("div", { className: "file-counter" },
                    React.createElement("h6", null,
                        React.createElement("strong", null,
                            props.attachments.length,
                            " files attached")),
                    React.createElement("div", { className: "download-button" },
                        React.createElement("button", { style: { border: 'none' }, onClick: function (e) { return downloadAll(e, props.attachments); } },
                            React.createElement("h6", null,
                                React.createElement("img", { src: "./download.svg" }),
                                React.createElement("strong", null, " Download All"))))) : null)))));
}
function Message(props) {
    var getReplyType = function (type) {
        if (type == "Call")
            return "./callgrey.svg";
        else {
            return "./chat.svg";
        }
    };
    return (React.createElement(reactstrap_1.Row, { className: "row-component" },
        React.createElement(reactstrap_1.Col, { lg: "12" },
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { lg: "8", id: "message-header" },
                    React.createElement("div", null,
                        React.createElement("img", { className: "customer-pic", src: props.data && props.data.creatorProfilePic ? props.data.creatorProfilePic : './images/customer-icon.png' })),
                    React.createElement("div", { id: "message-sender" },
                        React.createElement("span", null,
                            React.createElement("h6", null,
                                React.createElement("strong", null, props.data.creatorName),
                                " ",
                                React.createElement("img", { src: getReplyType(props.data.replyType) }))))),
                React.createElement(reactstrap_1.Col, { lg: "4", id: "date-col" },
                    React.createElement("div", { id: "message-date" },
                        React.createElement("span", null,
                            React.createElement("h6", null,
                                React.createElement(react_moment_1.default, { format: "DD MMM YYYY" }, props.data.createdAt)))))),
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { lg: "1" }),
                React.createElement(reactstrap_1.Col, { lg: "11" },
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: props.data.content } }))),
            React.createElement(Document, { attachments: props.data.attachments }),
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { lg: "1" }),
                React.createElement(reactstrap_1.Col, { lg: "11" },
                    React.createElement("div", { id: "reply-status" },
                        React.createElement("span", null,
                            React.createElement("h6", null,
                                props.data.replyType == 'Call' ? 'Call made' : 'Replied',
                                " by ",
                                props.data.creatorName,
                                " at ",
                                React.createElement(react_moment_1.default, { format: "h:mm a" }, props.data.createdAt)))))))));
}
function HoursForm(props) {
    return (React.createElement(reactstrap_1.Form, null,
        React.createElement(reactstrap_1.Row, { form: true },
            React.createElement(reactstrap_1.Col, { md: 12 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Hours" }, "Hours"),
                    React.createElement(reactstrap_1.Input, { value: props.inputValue, onChange: function (e) { return props.onChangeCallback(e, "Hours"); }, type: "number", name: "Hours", id: "Hours", max: "23", placeholder: "Insert hours" }))))));
}
function DaysForm(props) {
    return (React.createElement(reactstrap_1.Form, null,
        React.createElement(reactstrap_1.Row, { form: true },
            React.createElement(reactstrap_1.Col, { md: 12 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Days" }, "Days"),
                    React.createElement(reactstrap_1.Input, { value: props.inputValue, onChange: function (e) { return props.onChangeCallback(e, "Days"); }, type: "number", name: "Days", id: "Days", placeholder: "Insert Days" }))))));
}
var TicketPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var ticketId = parseInt(props.match.params.id, 10) || 0;
    var _a = (0, react_2.useState)(0), id = _a[0], setId = _a[1];
    var _b = (0, react_2.useState)(false), chatField = _b[0], setChatField = _b[1];
    var _c = (0, react_2.useState)({
        ticketId: 0,
        ticketNum: "",
        tier: "basic",
        title: "",
        description: "",
        name: "",
        creatorName: "",
        displayName: "",
        email: "",
        phoneNumber: "",
        status: "",
        address: "",
        companyAddress: "",
        industry: "",
        language: "",
        country: "",
        createdAt: "",
        modifiedAt: "",
        profilepic: "",
        resolutionTime: 0,
        creatorEmail: "",
        creatorPhoneNumber: "",
        creatorStatus: "",
        creatorProfilePic: "",
        package: "",
        comments: new Array()
    }), data = _c[0], setData = _c[1];
    var _d = (0, msal_react_1.useMsal)(), inProgress = _d.inProgress, instance = _d.instance, accounts = _d.accounts;
    var _e = (0, react_2.useState)({ id: "" }), graphData = _e[0], setGraphData = _e[1];
    var _f = (0, react_2.useState)(''), ticketStatus = _f[0], setTicketStatus = _f[1];
    var _g = (0, react_2.useState)(''), replyData = _g[0], setReplyData = _g[1];
    var _h = (0, react_2.useState)(data.resolutionTime), inputResolutionTime = _h[0], setInputResolutionTime = _h[1];
    var _j = (0, react_2.useState)(''), SLABreachType = _j[0], setSLABreachType = _j[1];
    var _k = (0, react_2.useState)(new Array()), attachments = _k[0], setAttachments = _k[1];
    var fileInput = (0, react_2.useRef)(null);
    var ReplyDocument = function (props) {
        // delete file button
        var files = attachments;
        var deleteFile = function (id) {
            for (var i = 0; i < files.length; i++) {
                if (files[i].id === id) {
                    files.splice(i, 1);
                    setAttachments(__spreadArray([], files, true));
                }
            }
        };
        return (React.createElement(reactstrap_1.Row, { className: "row-component" },
            React.createElement(reactstrap_1.Col, { lg: "12", id: "file-upload-col" },
                React.createElement("div", { className: "file-upload" },
                    React.createElement("div", { id: "upload-content" }, attachments ? attachments.map(function (item) { return (React.createElement("div", { className: "content" },
                        React.createElement("h6", null,
                            React.createElement("img", { src: "./insertphoto.svg" }),
                            " ",
                            item.name),
                        React.createElement("a", { className: "padding-default", onClick: function () { return deleteFile(item.id); } },
                            React.createElement("img", { src: "./delete.svg", className: "font-icon" })))); }) : null),
                    React.createElement("div", { id: "uploadDocument" }, attachments.length > 0 ? React.createElement("div", { className: "file-counter" },
                        React.createElement("h6", null,
                            React.createElement("strong", null,
                                attachments.length,
                                " files attached"))) : null)))));
    };
    var saveFile = function (e) {
        for (var i = 0; i < e.target.files.length; i++) {
            var _attachments = attachments;
            _attachments.push({
                file: e.target.files[i],
                name: e.target.files[i].name,
                path: '#'
            });
            setAttachments(__spreadArray([], _attachments, true));
        }
    };
    var handleClick = function () {
        fileInput.current.click();
    };
    var updateResoTime = function (evt, type) {
        var val = evt.target.value;
        setInputResolutionTime(val);
        (0, ticket_1.updateResolutionTime)(data.ticketId, type, val)
            .then(function (res) {
            var newData = data;
            if (type == "Days") {
                newData.resolutionTime = val * 24;
            }
            else {
                newData.resolutionTime = val;
            }
            setData(__assign({}, newData));
        }).catch(console.error);
    };
    function RequestProfileData() {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent(__assign(__assign({}, authConfig_1.loginRequest), { account: accounts[0] })).then(function (response) {
            (0, graph_1.callMsGraph)("GET", response.accessToken, authConfig_1.graphConfig.graphMeEndpoint).then(function (response) {
                console.log(response);
                setGraphData(response);
            });
        });
    }
    //this is for modals component for ReplyComment DateTime picker
    var _l = (0, react_2.useState)(false), modal = _l[0], setModal = _l[1];
    var toggle = function () { return setModal(!modal); };
    var _m = (0, react_2.useState)(''), callDate = _m[0], setCallDate = _m[1];
    var _o = (0, react_2.useState)(''), callTime = _o[0], setCallTime = _o[1];
    var _p = (0, react_2.useState)(''), callDateTime = _p[0], setCallDateTime = _p[1];
    function handleCallDate(event) {
        setCallDate(event.target.value);
    }
    function handleCallTime(event) {
        setCallTime(event.target.value);
    }
    var submitCallDateTime = function () {
        var callDateTime = callDate + 'T' + callTime + ":00";
        setCallDateTime(callDateTime);
        toggle();
    };
    var onLoad = function () {
        if (ticketId) {
            setId(ticketId);
        }
        (0, ticket_1.fetchTicket)(ticketId).then(function (result) {
            setData(result);
            setTicketStatus(result.status.toLowerCase());
        }).catch(console.error);
        (0, ticket_1.fetchSLAStatus)(ticketId).then(function (result) {
            setSLABreachType(result);
        }).catch(console.error);
    };
    function getData(val) {
        setChatField(true);
        setReplyData(val.target.value);
    }
    ;
    var replyCommentCall = function (e) {
        e.preventDefault();
        if (replyData == null || replyData.length === 0) {
            return alert('content is empty');
        }
        var userId = "";
        if (graphData != null && graphData.id != null) {
            userId = graphData.id;
        }
        var formData = new FormData();
        formData.append("Content", replyData.replace(/\n/g, "<br>"));
        formData.append("UserId", userId);
        formData.append("ReplyType", selectedMessageType);
        formData.append("CallDateTime", callDateTime);
        var headerObj = {
            'content-type': "multipart/form-data;",
        };
        if (attachments != null) {
            attachments.map(function (item) {
                formData.append("Attachments", item.file);
            });
            if (attachments != null) {
                headerObj['content-type'] = headerObj['content-type'] + ' boundary=${formData._boundary}';
            }
        }
        (0, ticket_1.replyTicketComment)(ticketId, formData, headerObj).then(function (result) {
            setReplyData('');
            setCallDateTime('');
            setAttachments(__spreadArray([], new Array(), true));
            //lps dh post comment, update ui dgn comment terbaru
            var newData = data;
            console.log(newData);
            newData.comments.push(result);
            //setData(...newData);  //setData({ ...newData }) setData(newData)
            setData(__assign({}, newData));
            //fetchTicket(ticketId).then((result: any) => setData(result)).catch(console.error);
        }).catch(function (e) {
            alert(e);
        });
    };
    (0, react_2.useEffect)(function () {
        if (data.ticketId == 0 && inProgress === msal_browser_1.InteractionStatus.None) {
            onLoad();
            RequestProfileData();
        }
    }, [inProgress, data, setData, ticketStatus, setTicketStatus, instance, callDate, setCallDate, callTime, setCallTime]);
    var handleUpdateTicketStatus = function (event) {
        setTicketStatus(event.target.value);
        (0, ticket_1.updateTicketStatus)(data.ticketId, event.target.value, graphData.id).then(function (data) {
        }).catch(console.error);
    };
    var ticketStatusOptions = [
        { key: 'unattended', value: 'Unattended' },
        { key: 'attended', value: 'Attended' },
        { key: 'inprogress', value: 'In-Progress' },
        { key: 'closed', value: 'Mark as Close' }
    ];
    var ticketSLABreachs = [
        //{ key: 'none', value: '~/slabreach/slabreach_none.png' },
        { key: 'timetoattend', label: 'SLA Breached: Time to Attend', value: './slabreach/slabreach_timetoattend.png' },
        { key: 'timetoresolution', label: 'SLA Breached: Time to Set Resolution Time', value: './slabreach/slabreach_timetoresolution.png' },
        { key: 'timetocompletion', label: 'SLA Breached: Time to Complete', value: './slabreach/slabreach_timetocompletion.png' },
        { key: 'timetoinittialcall', label: 'SLA Breached: Time to Initiate Call', value: './slabreach/slabreach_timetoinittialcall.png' }
    ];
    //this is for dropdown and modals component for resolution time
    var _q = (0, react_2.useState)(false), dropdownOpen = _q[0], setDropdownOpen = _q[1];
    var checkResolutionTimeRule = function () {
        return ticketStatus == 'attended' && inputResolutionTime == 0 && (data.resolutionTime == null || data.resolutionTime == 0);
    };
    var toggleDropdown = function () {
        if (checkResolutionTimeRule()) {
            setDropdownOpen(function (prevState) { return !prevState; });
        }
    };
    var _r = (0, react_2.useState)(false), modalHours = _r[0], setModalHours = _r[1];
    var _s = (0, react_2.useState)(false), modalDays = _s[0], setModalDays = _s[1];
    var _t = (0, react_2.useState)("Message"), selectedMessageType = _t[0], setSelectedMessageType = _t[1];
    var toggleHours = function () { return setModalHours(!modalHours); };
    var toggleDays = function () { return setModalDays(!modalDays); };
    //this is for Customer Info in mobile screen
    var _u = (0, react_2.useState)(false), mobileModal = _u[0], setMobileModal = _u[1];
    var toggleMobileModal = function () { return setMobileModal(!mobileModal); };
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_2.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "Ticket"))),
            React.createElement(reactstrap_1.Container, { fluid: true },
                React.createElement(reactstrap_1.Row, { className: "main-row" },
                    React.createElement(reactstrap_1.Col, { lg: "8", className: "main-col" },
                        React.createElement(reactstrap_1.Row, { className: "row-component" },
                            React.createElement(reactstrap_1.Col, { lg: "6" },
                                React.createElement("div", null,
                                    React.createElement(reactstrap_1.Row, { id: "ticket-status" },
                                        React.createElement(reactstrap_1.Col, { lg: "12", className: "ticketStatus-header", style: { display: 'inherit' } },
                                            React.createElement("h5", null,
                                                React.createElement("strong", null, data.title)),
                                            React.createElement("div", { className: "d-block d-md-none d-lg-none" },
                                                React.createElement(reactstrap_1.Button, { color: "danger", onClick: toggleMobileModal, style: { background: 'none', border: 'none' } },
                                                    " ",
                                                    React.createElement("img", { src: "./images/TripleDots.svg" })),
                                                React.createElement(reactstrap_1.Modal, { isOpen: mobileModal, toggle: toggleMobileModal, centered: true, backdrop: false },
                                                    React.createElement(reactstrap_1.ModalHeader, { toggle: toggleMobileModal }),
                                                    React.createElement(reactstrap_1.ModalBody, null,
                                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                                            React.createElement(reactstrap_1.Row, { className: "side-row" },
                                                                React.createElement(reactstrap_1.Col, { lg: "12", className: "Customer-info" },
                                                                    React.createElement(reactstrap_1.Row, { className: "side-row" },
                                                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                                                            React.createElement("div", { className: "Customer-logo" },
                                                                                React.createElement("img", { className: "customer-pic", src: data && data.creatorProfilePic ? data.creatorProfilePic : './images/customer-icon.png', style: { width: '48px', height: '48px' } })))),
                                                                    React.createElement(reactstrap_1.Row, { className: "side-row" },
                                                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                                                            React.createElement("div", { className: "Customer-name" },
                                                                                React.createElement("h5", null,
                                                                                    React.createElement("strong", null, data && data.creatorName ? data.creatorName : ''))))),
                                                                    React.createElement(reactstrap_1.Row, { className: "side-row" },
                                                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                                                            React.createElement("div", { className: "Customer-status" },
                                                                                React.createElement("h6", null, "Customer")))))),
                                                            React.createElement(reactstrap_1.Row, null,
                                                                React.createElement(reactstrap_1.Col, { lg: "12" },
                                                                    React.createElement("div", { className: "Info-title" },
                                                                        React.createElement("span", null,
                                                                            React.createElement("h6", null,
                                                                                React.createElement("strong", null, "User Information")))),
                                                                    data && data.creatorEmail ? React.createElement("div", { id: "Customer-email" },
                                                                        React.createElement("span", null,
                                                                            React.createElement("h6", null,
                                                                                React.createElement("img", { src: "./mail.svg" }),
                                                                                data.creatorEmail))) : null,
                                                                    data && data.creatorPhoneNumber ? React.createElement("div", { id: "Customer-contact" },
                                                                        React.createElement("span", null,
                                                                            React.createElement("h6", null,
                                                                                React.createElement("img", { src: "./callgrey.svg" }),
                                                                                data.creatorPhoneNumber))) : null,
                                                                    React.createElement("div", null,
                                                                        React.createElement(reactstrap_1.Row, null,
                                                                            React.createElement(reactstrap_1.Col, { lg: "6" },
                                                                                React.createElement("div", null,
                                                                                    React.createElement("span", null,
                                                                                        React.createElement("h6", null,
                                                                                            React.createElement("strong", null, "Ticket No:"),
                                                                                            data.ticketNum)))),
                                                                            React.createElement(reactstrap_1.Col, { lg: "6" },
                                                                                React.createElement("div", null,
                                                                                    React.createElement("span", null,
                                                                                        React.createElement("h6", null,
                                                                                            React.createElement("strong", null, "Requested:"),
                                                                                            data.creatorName)))))),
                                                                    React.createElement("div", null,
                                                                        React.createElement(reactstrap_1.Row, null,
                                                                            React.createElement(reactstrap_1.Col, { lg: "6" },
                                                                                React.createElement("div", { id: "Cust-Status" },
                                                                                    React.createElement("span", null,
                                                                                        React.createElement("h6", null,
                                                                                            React.createElement("strong", null, "Status:"),
                                                                                            data.creatorStatus)))),
                                                                            React.createElement(reactstrap_1.Col, { lg: "6" })))))))))),
                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                            React.createElement("h6", null, data.ticketNum)),
                                        React.createElement(reactstrap_1.Col, { lg: "12" },
                                            React.createElement("h6", null, data.package))))),
                            React.createElement(reactstrap_1.Col, { lg: "2" }, data.tier.toLowerCase() != 'basic' && SLABreachType && SLABreachType.length > 0 ?
                                ticketSLABreachs.map(function (item) {
                                    if (item.key == SLABreachType) {
                                        return (React.createElement("div", null,
                                            React.createElement(react_1.default, { content: item.label },
                                                React.createElement("img", { className: "icon-slabreach", src: item.value }))));
                                    }
                                }) : null),
                            React.createElement(reactstrap_1.Col, { lg: "4", className: "Resolution-time" }, data.tier.toLowerCase() != 'basic' ? React.createElement(reactstrap_1.Dropdown, { isOpen: dropdownOpen, toggle: toggleDropdown },
                                React.createElement(reactstrap_1.DropdownToggle, { caret: true, color: "", id: "Reso-Dropdown" },
                                    "Resolution Time: ",
                                    data.resolutionTime < 24 ? data.resolutionTime : data.resolutionTime / 24,
                                    " ",
                                    data.resolutionTime < 24 ? "hours" : "days"),
                                React.createElement(reactstrap_1.DropdownMenu, null,
                                    React.createElement(reactstrap_1.DropdownItem, { header: true }, "Choose Time Option"),
                                    React.createElement(reactstrap_1.DropdownItem, null,
                                        React.createElement(reactstrap_1.Button, { color: "danger", onClick: toggleHours }, "Hours"),
                                        React.createElement(reactstrap_1.Modal, { isOpen: modalHours, toggle: toggleHours, className: "Hours" },
                                            React.createElement(reactstrap_1.ModalHeader, { toggle: toggleHours }, "Resolution Time"),
                                            React.createElement(reactstrap_1.ModalBody, null,
                                                React.createElement(HoursForm, { inputValue: inputResolutionTime, onChangeCallback: updateResoTime })),
                                            React.createElement(reactstrap_1.ModalFooter, null,
                                                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggleHours }, "Cancel"),
                                                ' ',
                                                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: toggleHours }, "Confirm")))),
                                    React.createElement(reactstrap_1.DropdownItem, null,
                                        React.createElement(reactstrap_1.Button, { color: "danger", onClick: toggleDays }, "Days"),
                                        React.createElement(reactstrap_1.Modal, { isOpen: modalDays, toggle: toggleDays, className: "Days" },
                                            React.createElement(reactstrap_1.ModalHeader, { toggle: toggleDays }, "Resolution Time"),
                                            React.createElement(reactstrap_1.ModalBody, null,
                                                React.createElement(DaysForm, { inputValue: inputResolutionTime, onChangeCallback: updateResoTime })),
                                            React.createElement(reactstrap_1.ModalFooter, null,
                                                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggleDays }, "Cancel"),
                                                ' ',
                                                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: toggleDays }, "Confirm")))))) : null)),
                        React.createElement(reactstrap_1.Row, { id: "header-end" },
                            React.createElement(reactstrap_1.Col, { lg: "7" }),
                            React.createElement(reactstrap_1.Col, { lg: "5" },
                                React.createElement("div", { id: "status" },
                                    React.createElement("select", { disabled: ticketStatus == 'closed', name: "status", id: "status", value: ticketStatus, onChange: handleUpdateTicketStatus }, ticketStatusOptions.map(function (option) { return (React.createElement("option", { key: option.key, value: option.key }, option.value)); }))))),
                        data && data.comments ? data.comments.map(function (item) { return (React.createElement(Message, { data: item })); }) : null,
                        React.createElement(reactstrap_1.Row, { className: "row-component" },
                            React.createElement(reactstrap_1.Col, { lg: "12" },
                                React.createElement("div", { className: "row-component" },
                                    React.createElement(reactstrap_1.Row, null,
                                        React.createElement(reactstrap_1.Col, { lg: "12", className: "Chatbox" },
                                            React.createElement(reactstrap_1.Row, { className: "Chatbox-header" },
                                                React.createElement(reactstrap_1.Col, { lg: "3", id: "chat-title" },
                                                    React.createElement(reactstrap_1.Button, { type: "button", color: "link", className: "btn-reset ".concat(selectedMessageType == 'Message' ? 'btn-reset--active ' : ''), onClick: function (e) { return setSelectedMessageType("Message"); } },
                                                        React.createElement("h6", null,
                                                            React.createElement("strong", null, "Reply via Message")))),
                                                data.tier.toLowerCase() == 'premium' ?
                                                    React.createElement(reactstrap_1.Col, { lg: "3", id: "chat-title" },
                                                        React.createElement(reactstrap_1.Button, { type: "button", color: "link", className: "btn-reset ".concat(selectedMessageType == 'Call' ? 'btn-reset--active ' : ''), onClick: function (e) { return setSelectedMessageType("Call"); } },
                                                            React.createElement("h6", null,
                                                                React.createElement("strong", null, "Reply via Call")))) : null),
                                            React.createElement("div", { className: "Chatbox-body" },
                                                React.createElement(reactstrap_1.FormGroup, null,
                                                    React.createElement(reactstrap_1.Input, { disabled: ticketStatus == 'closed', type: "textarea", name: "text", id: "chatarea", value: replyData, onChange: getData })),
                                                selectedMessageType == 'Call' && callDateTime == '' ? React.createElement("div", { className: "CallDateTime-status" },
                                                    React.createElement("a", { onClick: toggle }, "Select Call DateTime"),
                                                    React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, centered: true },
                                                        React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Select Date & Time"),
                                                        React.createElement(reactstrap_1.ModalBody, null,
                                                            React.createElement(reactstrap_1.Form, null,
                                                                React.createElement(reactstrap_1.FormGroup, null,
                                                                    React.createElement(reactstrap_1.Label, { for: "ReplyDate" }, "Date"),
                                                                    React.createElement(reactstrap_1.Input, { type: "date", name: "ReplyDate", id: "ReplyDate", onChange: handleCallDate })),
                                                                React.createElement(reactstrap_1.FormGroup, null,
                                                                    React.createElement(reactstrap_1.Label, { for: "ReplyTime" }, "Time"),
                                                                    React.createElement(reactstrap_1.Input, { type: "time", name: "ReplyTime", id: "ReplyTime", onChange: handleCallTime })))),
                                                        React.createElement(reactstrap_1.ModalFooter, null,
                                                            React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                                                            ' ',
                                                            React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitCallDateTime(); } }, "Confirm")))) : "",
                                                selectedMessageType == 'Call' && callDateTime != '' ? React.createElement("div", { className: "CallDateTime-status" },
                                                    React.createElement("a", null,
                                                        " Selected Call DateTime: ",
                                                        React.createElement(react_moment_1.default, { format: "DD MMM YYYY" }, callDateTime),
                                                        " at ",
                                                        React.createElement(react_moment_1.default, { format: "h:mm a" }, callDateTime))) : ""),
                                            React.createElement(ReplyDocument, { attachments: attachments }),
                                            React.createElement("div", { className: "Chatbox-footer" },
                                                React.createElement("div", { className: "footer-component" },
                                                    React.createElement(reactstrap_1.Button, { color: "primary", id: "reply-button", onClick: replyCommentCall }, "Reply")),
                                                React.createElement("div", { className: "footer-component" },
                                                    React.createElement("input", { name: "Attachments", id: "Attachments", ref: fileInput, onChange: saveFile, type: "file", style: { display: "none" }, multiple: true }),
                                                    React.createElement("button", { style: { border: 'none' }, className: "btn btn-link", type: "button", onClick: handleClick },
                                                        React.createElement("img", { src: "./attachment.svg" }))),
                                                React.createElement("div", { className: "footer-component" },
                                                    React.createElement("a", null,
                                                        React.createElement("img", { src: "./emoticon.svg" }))),
                                                React.createElement("div", { className: "footer-component" },
                                                    React.createElement("a", null,
                                                        React.createElement("img", { src: "./photoupload.svg" })))))))))),
                    React.createElement(reactstrap_1.Col, { lg: "4", className: "d-none d-md-block d-lg-block" },
                        React.createElement(reactstrap_1.Row, { className: "side-row" },
                            React.createElement(reactstrap_1.Col, { lg: "12", className: "Customer-info" },
                                React.createElement(reactstrap_1.Row, { className: "side-row" },
                                    React.createElement(reactstrap_1.Col, { lg: "12" },
                                        React.createElement("div", { className: "Customer-logo" },
                                            React.createElement("img", { className: "customer-pic", src: data && data.creatorProfilePic ? data.creatorProfilePic : './images/customer-icon.png' })))),
                                React.createElement(reactstrap_1.Row, { className: "side-row" },
                                    React.createElement(reactstrap_1.Col, { lg: "12" },
                                        React.createElement("div", { className: "Customer-name" },
                                            React.createElement("h5", null,
                                                React.createElement("strong", null, data && data.creatorName ? data.creatorName : ''))))),
                                React.createElement(reactstrap_1.Row, { className: "side-row" },
                                    React.createElement(reactstrap_1.Col, { lg: "12" },
                                        React.createElement("div", { className: "Customer-status" },
                                            React.createElement("h6", null, "Customer")))))),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { lg: "12" },
                                React.createElement("div", { className: "Info-title" },
                                    React.createElement("span", null,
                                        React.createElement("h6", null,
                                            React.createElement("strong", null, "User Information")))),
                                data && data.creatorEmail ? React.createElement("div", { id: "Customer-email" },
                                    React.createElement("span", null,
                                        React.createElement("h6", null,
                                            React.createElement("img", { src: "./mail.svg" }),
                                            data.creatorEmail))) : null,
                                data && data.creatorPhoneNumber ? React.createElement("div", { id: "Customer-contact" },
                                    React.createElement("span", null,
                                        React.createElement("h6", null,
                                            React.createElement("img", { src: "./callgrey.svg" }),
                                            data.creatorPhoneNumber))) : null,
                                React.createElement("div", null,
                                    React.createElement(reactstrap_1.Row, null,
                                        React.createElement(reactstrap_1.Col, { lg: "6" },
                                            React.createElement("div", null,
                                                React.createElement("span", null,
                                                    React.createElement("h6", null,
                                                        React.createElement("strong", null, "Ticket No:"),
                                                        data.ticketNum)))),
                                        React.createElement(reactstrap_1.Col, { lg: "6" },
                                            React.createElement("div", null,
                                                React.createElement("span", null,
                                                    React.createElement("h6", null,
                                                        React.createElement("strong", null, "Requested:"),
                                                        data.creatorName)))))),
                                React.createElement("div", null,
                                    React.createElement(reactstrap_1.Row, null,
                                        React.createElement(reactstrap_1.Col, { lg: "6" },
                                            React.createElement("div", { id: "Cust-Status" },
                                                React.createElement("span", null,
                                                    React.createElement("h6", null,
                                                        React.createElement("strong", null, "Status:"),
                                                        data.creatorStatus)))),
                                        React.createElement(reactstrap_1.Col, { lg: "6" })))))))))));
};
exports.default = TicketPage;
//# sourceMappingURL=TicketPage.js.map